import { USER_DETAIL } from '../constants/userdetails';

const initialState = {};

const userDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_DETAIL:
      return {
        ...state,
        userDetail: action.payload,
      };
    default:
      return state;
  }
};
export default userDetailReducer;
